import AntMenu from "antd/es/menu";
import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc.ts";
import { BOTTOM_NAVIGATOR } from "common/constants.ts";

const Menu = styled(AntMenu)`
  .ant-menu-item-selected a::before {
    border-right: 3px solid ${(p) => p.theme.colors.primaryBlue};
  }
  &.ant-menu-inline .ant-menu-sub.ant-menu-inline {
    background: ${(p) => hexToRGB(p.theme.colors.lightestGrey, 0.08)};
  }
  @media (min-width: ${BOTTOM_NAVIGATOR}) {
    .ant-menu-submenu-title:hover {
      color: ${(p) => p.theme.colors.primaryBlue};
    }
  }
`;

export default Menu;
